import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface ScrollRevealProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  duration?: number;
  y?: number;
}
export function ScrollReveal({
  children,
  className = '',
  delay = 0,
  duration = 0.5,
  y = 24
}: ScrollRevealProps) {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-40px'
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y
  }} transition={{
    duration,
    delay,
    ease: [0.25, 0.1, 0.25, 1]
  }} className={className} data-id="element-266">
      {children}
    </motion.div>;
}